import { useQuery } from '@tanstack/react-query';

import { getListProjectMeasurementActions } from '@features/GenerateMeasurement/api/getListProjectMeasurementActions';
import { IListProjectMeasurementActions, IListProjectMeasurementActionsDTO } from '@features/GenerateMeasurement/model/types';
import { keysToCamel } from '@shared/helpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const useGetListProjectMeasurementActionsQuery = () => {
    const { isLoading, isFetching, data, isSuccess } = useQuery<
        IDataResponse<IListProjectMeasurementActionsDTO>,
        Error,
        IListProjectMeasurementActions
    >({
        queryKey: ['listProjectMeasurementActions'],
        queryFn: getListProjectMeasurementActions,
        staleTime: 1000 * 60 * 5,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        select: (response: IDataResponse<IListProjectMeasurementActionsDTO>) => keysToCamel(response.data),
    });

    return { isLoading, isFetching, isSuccess, data };
}